const FiltroHeader = ({nombre, opciones = null, nombreProp = null, callback = null}) => {
    return (
        <th>{nombre}</th>
    )
}
export default FiltroHeader;